<div class="form-group">
  New: Name = <input [(ngModel)]="createNew.name" (ngModelChange)="changedName()" class="new-input"/>
  Url = <input [(ngModel)]="createNew.url" class="new-input"/>
  <button type="button" class="btn btn-sm btn-primary" (click)="createNewNow()">Create</button>
</div>
<div>
  <button class="btn btn-sm btn-primary" (click)="loadData()">reload state</button>
</div>

@for (pkg of state; track pkg.id) {
  <div class="card">
    <div class="card-body">
      <div class="card-title" [classList]="getProjectStyles(pkg)">
        <div (click)="togglePackage(pkg)">
          {{pkg.name}} ({{pkg.id}}) - <a [href]="pkg.url" target="_blank">{{pkg.url}}</a> wantedOnItsOwn:{{pkg.wantedOnItsOwn}}
        </div>
        <br>
          last check at {{pkg.lastRepoCheck}} - {{pkg.lastRepoHash}}
          <button type="button" class="btn btn-sm btn-primary" (click)="buildNow(pkg); $event.stopPropagation()">build now</button>
        </div>
        @if (isExpanded('' + pkg.id)) {
          <div class="card-text">
            @for (build of getBuildsFor(pkg); track build.id) {
              <div class="card">
                <div class="card-body">
                  <div class="card-title" (click)="toggleBuild(pkg, build)" [classList]="getBuildStyles(build)">
                    Build from {{build.startTime}} - {{build.endTime}} - {{build.duration}}
                    @if (!build.success && !build.silenced) {
                      <button type="button" class="btn btn-sm btn-primary" (click)="silence(pkg, build); $event.stopPropagation()">silence build</button>
                    }
                  </div>
                  @if (isExpanded('' + pkg.id + '.' + build.id)) {
                    <div class="card-text">
                      @for (step of getStepsFor(build); track step.id) {
                        <div class="card">
                          <div class="card-body">
                            <div class="card-title" (click)="toggleExpanded('' + pkg.id + '.' + build.id + '.' + step.id)" [classList]="getStepStyles(step)">
                              Step {{step.stage}} (took {{step.duration}}, start {{step.startTime}} end {{step.endTime}})
                            </div>
                            @if (isExpanded('' + pkg.id + '.' + build.id + '.' + step.id)) {
                              <div class="card-text" >
                                <p class="command">
                                  {{step.command}}
                                </p>
                                <p class="output">
                                  {{step.output}}
                                </p>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
